<section class="sx-dialog__small">
    @if(isSessionReloaded){
      <header class="sx-dialog__content">
        <h2 class="sx-dialog__heading h3">{{ 'core.unauthorized.session_expired_repair_title' | translate }}</h2>
      </header>
      <div class="sx-dialog__content" [innerHtml]="'core.unauthorized.session_expired_repair_message' | translate "></div>
      <div class="sxh-button-footer sxl-align-right sxl-horizontal-stack-small">
          <button class="sx-button sx-button--wide sx-button--magenta" [disabled]="isRepairing" (click)="repairAccount()">{{ 'core.unauthorized.session_expired_try_again' | translate }}</button>
      </div>
    }
    @else {
      <header class="sx-dialog__content">
        <h2 class="sx-dialog__heading h3">{{ 'core.unauthorized.session_expired_title' | translate }}</h2>
      </header> 
      <div class="sx-dialog__content" [innerHtml]="'core.unauthorized.session_expired_message' | translate "></div>
      <div class="sxh-button-footer sxl-align-right sxl-horizontal-stack-small">
        <button class="sx-button sx-button--wide sx-button--magenta" [disabled]="isRepairing" mat-button (click)="reloadSession()">{{ 'core.unauthorized.session_expired_reload' | translate }}</button>
      </div>
    }
</section>
